import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useInvoicesList({ id }) {
  // Use toast
  const toast = useToast()

  const refInvoiceListTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'invoice_num', label: 'Invoice', sortable: false },
    { key: 'subject', label: 'Subject', sortable: false },
    { key: 'products_total', label: 'Total', sortable: false },
    { key: 'created_at', label: 'Date', sortable: false },
    { key: 'actions', label: 'Action', sortable: false }
  ]
  const perPage = ref(10)
  const totalInvoices = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')

  const dataMeta = computed(() => {
    const localItemsCount = refInvoiceListTable.value
      ? refInvoiceListTable.value.localItems.length
      : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalInvoices.value
    }
  })

  const refetchData = () => {
    refInvoiceListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery], () => {
    refetchData()
  })

  const fetchInvoices = (ctx, callback) => {
    let queryParams = {
      perPage: perPage.value,
      page: currentPage.value
    }

    console.log('MM', id)

    if (id) {
      queryParams['filters["matter_id"]'] = id
    }

    if (searchQuery.value) {
      queryParams['query'] = searchQuery.value
    }

    store
      .dispatch('invoiceStore/fetchInvoices', {
        ctx: this,
        queryParams: queryParams
      })
      .then((response) => {
        callback(response.data)
        totalInvoices.value = response.meta.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Error fetching invoices' list",
            icon: 'AlertTriangleIcon',
            variant: 'danger'
          }
        })
      })
  }

  return {
    fetchInvoices,
    tableColumns,
    perPage,
    currentPage,
    totalInvoices,
    dataMeta,
    perPageOptions,
    searchQuery,
    refInvoiceListTable,
    refetchData
  }
}
